var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-loader"},[_c('CCard',_vm._l((4),function(r){return _c('div',{staticClass:"t-loader__row"},_vm._l((3),function(i){return _c('vue-skeleton-loader',{attrs:{"type":"rect","rounded":"","width":'100%',"height":'20px',"animation":"fade"}})}),1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }